import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from 'react-final-form';

import CardWrapper, { EDIT_PROJECT_SECTION } from '../card-wrapper/CardWrapper';
import validate from '../../../utils/validate';
import { editProjectFileFormYupValidation } from '../validation';
import FileFormInner from './FileFormInner';

const FileSection = ({ onSubmit }) => {
  const { t } = useTranslation('projects');

  const fileInitialValue = {
    file: '',
  };

  const handleUpdateFile = (values, form) => {
    if (onSubmit) {
      onSubmit(values, form);
    }
  };

  return (
    <CardWrapper label={t('changeFile')} sectionType={EDIT_PROJECT_SECTION.FILE}>
      <Form
        initialValues={fileInitialValue}
        onSubmit={handleUpdateFile}
        subscription={{ submitting: true, pristine: true }}
        validate={(values) => validate(values, editProjectFileFormYupValidation())}
        render={({ handleSubmit }) => <FileFormInner onSubmit={handleSubmit} initialValues={fileInitialValue} />}
      />
    </CardWrapper>
  );
};

export default memo(FileSection);
